import { getColorScheme, useColorScheme } from './UseColorScheme';
export function useBorderStyle() {
    const theme = useColorScheme();
    if (theme.scheme === 'dark') {
        return {
            borderBottomWidth: 0,
            borderBottomColor: '#63788f',
            borderStyle: 'solid'
        };
    }
    return {
        borderBottomWidth: 1,
        borderBottomColor: '#F0EFEF',
        borderStyle: 'solid'
    };
}
export function getBorderStyle() {
    const theme = getColorScheme();
    if (theme.value.scheme === 'dark') {
        return {
            borderBottomWidth: 0,
            borderBottomColor: '#63788f',
            borderStyle: 'solid'
        };
    }
    return {
        borderBottomWidth: 1,
        borderBottomColor: '#F0EFEF',
        borderStyle: 'solid'
    };
}
